import { createSlice } from '@reduxjs/toolkit';

import { ISupportMeasuresState } from './interfaces';
import { loadSupportMeasuresItem, loadSupportMeasuresList } from './actions';

export const supportMeasuresSlice = createSlice({
  name: 'supportMeasures',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as ISupportMeasuresState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadSupportMeasuresList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadSupportMeasuresItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
